import styled from 'styled-components';
import { Menu } from '@cld/menu';
import { minWidthVariant, dropdownMenuTheme } from './theme';

export const StyledMenu = styled(Menu)`
  min-width: ${minWidthVariant((variant) => variant.minWidth)};
  padding-top: ${dropdownMenuTheme.menu.padding.vertical};
  padding-bottom: ${dropdownMenuTheme.menu.padding.vertical};
`;
